import React from 'react';
import { logError } from '../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logError(error, { componentStack: info?.componentStack });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{ padding: 24, fontFamily: 'Roboto, sans-serif' }}>
          <h1 style={{ fontSize: 18 }}>Panel hatası</h1>
          <p style={{ color: '#b91c1c', fontSize: 13 }}>
            {this.state.error?.message || String(this.state.error)}
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Yenile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
